namespace RedBullMOBILE360.Utilities {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.Utilities.ReAuthenticateNumbersGrid')
    export class ReAuthenticateNumbersGrid extends Serenity.EntityGrid<ReAuthenticateNumbersRow, any> {
        protected getColumnsKey() { return ReAuthenticateNumbersColumns.columnsKey; }
        protected getDialogType() { return ReAuthenticateNumbersDialog; }
        protected getIdProperty() { return ReAuthenticateNumbersRow.idProperty; }
        protected getInsertPermission() { return ReAuthenticateNumbersRow.insertPermission; }
        protected getLocalTextPrefix() { return ReAuthenticateNumbersRow.localTextPrefix; }
        protected getService() { return ReAuthenticateNumbersService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();
            //if (!Q.Authorization.userDefinition.IsAdmin)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push({
                title: 'Import List of numbers',
                cssClass: 'import-button',
                onClick: () => {
                    var dialog = new ReAuthExcelImportDialog();
                    dialog.dialogOpen();
                }
            });

            buttons.push(Serenity.Extensions.ExcelExportHelper.createToolButton({
                title: 'Download Template',
                grid: this,
                service: ReAuthenticateNumbersService.baseUrl + '/DownloadTemplate',
                onViewSubmit: () => this.onViewSubmit()
            }));

            return buttons;
        }

    }
}